import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, BrowserRouter as Router, Route, Link, useParams } from "react-router-dom";
function StreetView() {
    const [loading, setLoading] = useState(true);
    const [stbCount, setStbCount] = useState(true);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [error, setError] = useState(null);
    const [rowsData, setRowsData] = useState([]);
    const [streetCustomer, setStreetCustomer] = useState([]);
    const [wallet, setWalletAmount] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: "name", direction: "ascending" });
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(100);
    const user = getCookie('user');
    const [searchQuery, setSearchQuery] = useState("");
    const [formData, setFormData] = useState({ date: "", toDate: "" })
    const initialFormData = { date: "", toDate: "" }
    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) { return value; }
        } return null;
    }
    if (!user) { navigate('/'); }

    const downloadCSV = () => {
        const headers = ["Sno", "Customer__Name", "Acc_no", "Code", "STB_no", "D_no", "Flat_name", "Street__name", "Phone", "Pay Status", "Plan Amount", "Paid Amount", "Paid_Date", "Balance Amount", "Discount Amount", "Advance Amount", "Pending Amount", "Staff__Code", "Network", "Paid_time", "Package", "Added_date", "Collection Staff"];
        const csvRows = [];
        csvRows.push(headers.join(","));
        streetCustomer.forEach(row => { csvRows.push([row.id, row.name, row.account_num, row.acc_num, row.serial_num, row.doorno, row.flat_name, row.street, row.mobile, row.status, row.pay_amt, row.paid_amt, row.paid_date, row.balance, row.discount, row.extra_Balance_amt, row.pend_amt, row.area_code, row.net_name, row.paid_time, row.package, row.adate, row.col_boy].join(",")); });
        const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "CableTvPay.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = streetCustomer.slice(indexOfFirstRow, indexOfLastRow);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const totalPages = Math.ceil(streetCustomer.length / rowsPerPage);
    const filteredRows = currentRows.filter((row) => Object.values(row).some(value => String(value).toLowerCase().includes(searchQuery.toLowerCase())));
    const handleClear = () => { setFormData(initialFormData); };
    const { id } = useParams();

    const fetchUserData = async () => {
        if (!id) {
            console.error("❌ Missing area_code before API call.");
            return;
        }

        try {
            const response = await axios.post('https://node.cabletvpay.in/streetReportView', { user, id });
            if (response.status === 200) {
                setStbCount(response.data.customerDetails.length);
                setStreetCustomer(response.data.customerDetails);
            }
        } catch (err) {
            setError(err.response?.data?.message || "Error fetching data");
            console.log(err);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchUserData();
    }, []);


    if (loading) return (<div className="content-wrapper">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
            <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="0.75" ariaLabel="rotating-lines-loading" wrapperStyle={{}} wrapperClass="" />
        </div></div>)
    if (error) return (<div className="content-wrapper">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "73vh" }}>
            <img src="../asset/img/errorPage.jpg" alt="" style={{ height: "20rem" }} />
        </div></div>);
    return (
        <div className="content-wrapper">
            <div className="content-header pt-1">
                <h5 className='h5'>STAFF REPORT DETAILS</h5><hr className='mt-0' />
                <div style={{ position: 'absolute', top: '30px' }}><ToastContainer theme='dark' /></div>
                <div className="border-0 px-1">
                    <div className="row mx-3 d-flex justify-content-center">
                        <div className="col-lg-6 col-md-6 col-12 mb-2">
                            <h2 className="text-navy">
                                <span className="text-bold text-orange">{streetCustomer[0].net_name || "N/A"}</span> Report Details
                            </h2>
                        </div>

                    </div>

                </div>

                <div className="card elevation-5 mt-3 mt-lg-5" style={{ backgroundColor: "#cccccc" }}>
                    <div className="card-header filterBtn">
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="text-left mb-lg-0 w-50">
                                    <h4 className="pb-0 mb-0 mt-1 text-navy">Filter Details</h4>
                                </div>
                            </div>
                            <div className="col-lg-8 mt-1">
                                <span><div className="row w-auto">
                                    <div className="col-11 col-lg-6">
                                        <div className="input-group">
                                            <input type="text" className="form-control text-navy bg-light border-0 px-1 py-0" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} style={{ borderRadius: "5px 0 0 5px" }} />
                                            <span className="input-group-text bg-light text-navy border-0 px-2" id="basic-addon1" style={{ borderRadius: "0 5px 5px 0" }} > <i className="fas fa-search" /> </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 mt-1 mt-lg-0">
                                        <div className="d-flex justify-content-end">
                                            <div className=" btn-group">
                                                <button onClick={downloadCSV} className="btn btn-dark border-right px-lg-3 px-5 my-1 d-flex"><i className="fas fa-download pt-1 px-1" /> Download</button>

                                            </div>
                                        </div>
                                    </div>
                                </div></span>
                            </div>
                        </div>
                    </div>
                    <div className="card-body p-0">
                        <table id="myTable" className="table table-striped bg-white table-bordered table-responsive">
                            <thead className="bg-gradient-navy">
                                <tr>
                                    <th>Sl_No</th>
  <th>Status</th>
                                    <th>Customer__Name</th>
                                    <th>Acc_no</th>
                                    <th>Code</th>
                                    <th>STB_no</th>
                                    <th>Networks</th>
                                    <th>D_no</th>
                                    <th>Flat_name</th>
                                    <th>Street__name</th>
                                    <th>Phone</th>
                                    <th>Staff__Code</th>
                                    <th>Pay Status</th>
                                    <th>Plan Amount</th>
                                    <th>Paid Amount</th>
                                    <th>Paid__Date</th>
                                    <th>Paid_Time</th>
                                    <th>Balance Amount</th>
                                    <th>Discount Amount</th>
                                    <th>Advance Amount</th>
                                    <th>Pending Amount</th>

                                    <th>Collection_Staff</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredRows.length > 0 ? (filteredRows.map((row, index) => (
                                    <tr key={index} className='text-dark'>
                                        <td className='tableText border-dark text-bold'>{row.id}</td>
                                         <td className='tableText'>
                                                {row.con_status === "active" || row.con_status === "Active" ? (
                                                <div className="d-flex-column">
                                                    <button
                                                    className="btn btn-success"
                                                    
                                                    >
                                                    A
                                                    </button>
                                                
                                                </div>

                                                ) : row.con_status === "deactive" || row.con_status === "Deactive" ? (
                                                <div className="d-flex-column">
                                                    <button
                                                    className="btn btn-danger"
                                                    
                                                    >
                                                    D
                                                    </button>
                                                </div>
                                                ) : (
                                                <div className="d-flex-column"><button className="btn btn-secondary">{row.con_status}</button>{row.deactive_reason}</div>
                                                )}
                                        </td>
                                        <td className='tableText border-dark text-bold'>{row.name}</td>
                                        <td className='tableText border-dark text-bold'>{row.account_num}</td>
                                        <td className='tableText border-dark text-bold'>{row.acc_num}</td>
                                        <td className='tableText border-dark text-bold'>{row.serial_num}</td>
                                        <td className='tableText border-dark text-bold'>{row.net_name}</td>
                                        <td className='tableText border-dark text-bold'>{row.doorno}</td>
                                        <td className='tableText border-dark text-bold'>{row.flat_name}</td>
                                        <td className='tableText border-dark text-bold'>{row.street}</td>
                                        <td className='tableText border-dark text-bold'>{row.mobile}</td>
                                        <td className='tableText border-dark text-bold'>{row.area_code}</td>
                                        <td className='tableText border-dark text-bold'>{row.status}</td>
                                        <td className='tableText border-dark text-bold'>{row.pay_amt}</td>
                                        <td className='tableText border-dark text-bold'>{row.paid_amt}</td>
                                        <td className='tableText border-dark text-bold'>{row.paid_date}</td>
                                        <td className='tableText border-dark text-bold'>{new Date(`1970-01-01T${row.paid_time}`).toLocaleString([], { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true })}</td>
                                        <td className='tableText border-dark text-bold'>{row.balance_amt}</td>
                                        <td className='tableText border-dark text-bold'>{row.discount}</td>
                                        <td className='tableText border-dark text-bold'>{row.extra_balance_amt}</td>
                                        <td className='tableText border-dark text-bold'>{row.pend_amt}</td>


                                        <td className='tableText border-dark text-bold'>{row.col_boy}</td>
                                    </tr>
                                ))) : (<tr><td colSpan="10">No results found</td></tr>)}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="d-flex justify-content-end">
                    <div className="pagination btn-group">
                        <button className="btn bg-navy border-right" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} style={{ opacity: currentPage === 1 ? 0.6 : 1 }} ><i className="fas fa-backward"></i></button>
                        <button onClick={() => paginate(1)} className={`btn ${currentPage === 1 ? "bg-navy" : "btn-outline-secondary"} border-left`} > 1 </button>
                        {currentPage > 3 && <span className="mx-1">...</span>}
                        {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i).filter((page) => page > 1 && page < totalPages).map((page) => (<button key={page} onClick={() => paginate(page)} className={`btn ${currentPage === page ? "bg-navy" : "btn-outline-secondary"}`} style={{ fontWeight: currentPage === page ? "bold" : "normal" }} > {page} </button>))}
                        {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
                        {totalPages > 1 && (<button onClick={() => paginate(totalPages)} className={`btn ${currentPage === totalPages ? "bg-navy" : "btn-outline-secondary"} border-right`}>{totalPages}</button>)}
                        <button className="btn bg-navy  border-left" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} style={{ opacity: currentPage === totalPages ? 0.6 : 1 }} ><i className="fas fa-forward"></i></button>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default StreetView;
